import simpleHotkeys from 'simple-hotkeys';

const hotkeys = simpleHotkeys();
export function registerHotKey(shortcut, handler) {
  if (hotkeys.respondTo(shortcut)) {
    throw new Error('this shortcut already registered');
  }
  hotkeys.add(shortcut, handler);
}

export function unregisterHotKey(shortcut) {
  hotkeys.remove(shortcut);
}
